module.exports = __webpack_public_path__ + "img/BS-Silo-front.09bff6f8.png";